import toastBS5 from './toast.js';
import * as bootstrap from 'bootstrap';

/**
 *   entry point for the login.php view
 */

/**
 * encodeURIComponent() percent-encodes '@' to '%40', but the /magic-link and /password-reset
 * routes match it as a literal '@' (it's a valid unencoded path character per RFC 3986). Undo
 * just that one substitution so the URL keeps a literal '@' while everything else stays encoded.
 * @param {string} email
 * @returns {string}
 */
function encodeEmailPathSegment(email) {
  return encodeURIComponent(email).replace(/%40/g, '@');
}

/** Forgotten Password */
document.addEventListener('DOMContentLoaded', function () {
  const loginCard = document.querySelector('#loginCard');
  const pwdRestModalDiv = document.querySelector('#resetUserPasswordModal');
  const pwdResetForm = document.querySelector('#resetUserPasswordForm');

  // the login form is hidden by default with a check to see if JavaScript is enabled
  if (!loginCard || !pwdRestModalDiv || !pwdResetForm) {
    return;
  }
  loginCard.classList.remove('d-none');

  // Forgotten Password
  const forgottenPwdModal = new bootstrap.Modal(pwdRestModalDiv);

  // forgotten password protocol -- get the email address and generate an email
  pwdResetForm.addEventListener('submit', function (e) {
    e.preventDefault();
    console.log('submit resetUserPasswordForm');

    /** @type {HTMLInputElement|null} emailInputElement */
    const emailInputElement = document.querySelector('input[name="resetemail"]');
    if (!emailInputElement) {
      console.error('Unable to get email address from form');
      return;
    }

    const email = emailInputElement.value;

    if (email && email.length > 0) {
      fetch(`/password-reset/${encodeEmailPathSegment(email)}`, {
        'method': 'POST'
      })
        // AuthController::sendPasswordReset() replies {status: 1|0, data: {message}} itself, but an
        // uncaught exception (e.g. unregistered email) falls through to League\Route's JsonStrategy,
        // which replies {status_code, reason_phrase} instead - handle both shapes
        .then((response) => response.json().then((body) => ({ 'ok': response.ok, 'body': body })))
        .then(({ ok, body }) => {
          if (!ok || body.status === 0) {
            const message = body?.data?.message || body?.reason_phrase || 'Unable to send Password Reset email';
            toastBS5(message, 'error');
            return;
          }

          console.log('Success:', body);
          toastBS5('Password reset email sent', 'success');
          forgottenPwdModal.hide();
        })
        .catch((error) => {
          console.error(error);
          toastBS5('Unable to send Password Reset email', 'error');
        });
    }
  });
});

/**
 * deal with request for a Magic Link
 */
document.addEventListener('DOMContentLoaded', function () {
  const magicLinkForm = document.querySelector('#magicLinkForm');
  if (!magicLinkForm) {
    return;
  }

  magicLinkForm.addEventListener('submit', function (e) {
    e.preventDefault();
    console.log('Magic link requested');

    /** @type {HTMLFormElement|null} magicLinkForm */
    const magicLinkForm = document.querySelector('#magicLinkForm');
    if (magicLinkForm) {
      /** @type {HTMLInputElement|null} */
      const emailInputElement = magicLinkForm.querySelector('input[name="email"]');

      if (emailInputElement) {
        fetch(`/magic-link/${encodeEmailPathSegment(emailInputElement.value)}`, {
          'method': 'POST'
        })
          // AuthController::sendMagicLink() replies {status: 1|0, data: {message}} itself, but an
          // uncaught exception (e.g. unregistered email) falls through to League\Route's JsonStrategy,
          // which replies {status_code, reason_phrase} instead - handle both shapes
          .then((response) => response.json().then((body) => ({ 'ok': response.ok, 'body': body })))
          .then(({ ok, body }) => {
            if (!ok || body.status === 0) {
              const message = body?.data?.message || body?.reason_phrase || 'Unable to send Magic Link';
              toastBS5(message, 'error');
              return;
            }

            console.log('Success:', body);
            toastBS5('Magic link sent - please check your email', 'success');

            magicLinkForm.reset();
          })
          .catch((error) => {
            console.error(error);
            toastBS5('Unable to send Magic Link', 'error');
          });
      }
    }
  });
});

/**
 * process the Acknowledgement
 */
document.addEventListener('DOMContentLoaded', function () {
  // if value of this hidden input field is "truthy" we open the Acknowledge modal when the page loads
  /** @type {HTMLInputElement|null} */
  const emailResponse = document.querySelector('input[name="emailResponse"]');

  if (!emailResponse) {
    return;
  }

  if (emailResponse.value === '1') {
    const ackEsrModalId = 'ackEsrModal';
    const ackEsrModal = document.getElementById(ackEsrModalId);
    if (!ackEsrModal) {
      console.error('Modal not found - check "id" attribute is %s', ackEsrModalId);
      return;
    }

    const ackModal = new bootstrap.Modal(ackEsrModal);
    ackModal.show();
  }
});
